import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import videoOverlayManager from 'managers/videoOverlay';
import { EffectsContainer } from 'mixins/withEffects';
import WCCVideo from 'models/attachments/video';
import AttachmentControlVM from './control';
import './videoExpand.html';

export interface AttachmentVideoExpandControlVMConfig {
    video: WCCVideo
}

@injectable()
export default class AttachmentVideoExpandControlVM extends AttachmentControlVM {
    private video: WCCVideo

    constructor(
        @inject(wccModules.componentConfig) config: AttachmentVideoExpandControlVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) private effects: EffectsContainer
    ) {
        super(info);

        this.video = config.video;
    }

    click() {
        this.expand();
    }

    private expand() {
        this.effects.register(async () => {
            const stage = await videoOverlayManager.show(this.video);

            return () => stage.close();
        });        
    }
}